import axios from 'axios'

class ApiHandler {
  constructor() {
    this.http = axios
  }
}

export default ApiHandler

export const REQUEST_TIMEOUT = 50000
